export default class Validation {
    // tslint:disable-next-line:no-any
    static isRealNumber(value: any) {
        return (
            !isNaN(parseFloat(value)) &&
            value.toString().match(/(^[-]?([0-9]+)([,.][0-9]+)?)$/g) !== null
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Validation.tsx